<p-dialog
        [(visible)]="visible"
        [modal]="true"
        header="Enter Sales Codes"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <p class="text-gray-500 dark:text-gray-300 mb-4">
        Please enter the sales codes separated by commas.
    </p>
    <p-ifta-label>
          <textarea
                  id="sales-codes"
                  pTextarea
                  [(ngModel)]="salesCodes"
                  placeholder="e.g. Code1, Code2, Code3"
                  class="w-full"
          ></textarea>
        <label for="sales-codes">Sales Codes</label>
    </p-ifta-label>

    <div class="flex items-center justify-end gap-2 mt-6">
        <p-button label="Cancel" (onClick)="close()" severity="secondary"></p-button>
        <p-button label="Save" (onClick)="save()" severity="primary" [loading]="loading"></p-button>
    </div>
</p-dialog>